import Modal from './Modal'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'


function Transaction(props) {
    const [modal, setModal] = useState(false)

    const renderHashInfo = () => {

        let html =<ul className='modalListInfo p-3'>
            <li className='customShadow customRadius mb-4'>
                <h2 class="listInfoTitle">RELEASE ID</h2>
                <p  class="listInfoDescp">188</p>
            </li>
            <li className='customShadow customRadius mb-4'>
                <h2 class="listInfoTitle">TRANSACTION ID</h2>
                <p  class="listInfoDescp">0x958012a5a08749032bc0e758028f67092dc019c1e6d376cccb8c6cc5b44d75fb</p>
            </li>
            <li className='customShadow customRadius mb-4'>
                <h2 class="listInfoTitle">STATUS</h2>
                <p  class="listInfoDescp">Success</p>
            </li>
        </ul>

        return <div>
            {html}
        </div>
    }

    return <li className="d-flex beigeListItem pb-2 pt-0">
            <div className="d-flex w-100 flex-column" onClick={() => setModal(!modal)}>
                <div className="beigeListIcon d-flex justify-content-center align-items-center">
                    <FontAwesomeIcon icon={faChartLine}  />
                </div>
                <div className="beigeListInfo pl-2" >
                    <h3 className="beigelistTitle mb-0">HASH</h3>
                </div>
            </div>
        {modal && <Modal title="Blockchain Transaction" modal={modal} toggleModal={setModal}>{renderHashInfo()}</Modal>}
    </li>
}


export default Transaction